// This file was generated using `pay js:run gql-v1 --type=fragment --name=AuthenticatedUser --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';

import type {
  Exact,
  OpenapiConnectAuthResourcesUserObjectFieldType,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment AuthenticatedUserFragment on OpenapiConnectAuthResourcesUser {
    id
    object
    is_primary_user
    has_onboarding_permissions
  }
`;

export const authenticatedUserFragment: AuthenticatedUserFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type AuthenticatedUserFragmentData = {
  readonly __typename: 'OpenapiConnectAuthResourcesUser';
  readonly id: string;
  readonly object: OpenapiConnectAuthResourcesUserObjectFieldType;
  readonly is_primary_user: boolean | null;
  readonly has_onboarding_permissions: boolean | null;
};

export type AuthenticatedUserFragmentVariables = Exact<{[key: string]: never}>;

const authenticatedUserFragmentPermissions = {} as const;

doc.permissions = authenticatedUserFragmentPermissions;

export type AuthenticatedUserFragmentPermissions = V1PermissionToken<
  typeof authenticatedUserFragmentPermissions
>;

export type AuthenticatedUserFragmentDocument = GraphQlDocument<
  AuthenticatedUserFragmentData,
  AuthenticatedUserFragmentVariables,
  AuthenticatedUserFragmentPermissions
>;
